import {sendRequest} from "./Sender";

export const CashService = {
    GetList,
    Update,
    GetCategories,
    Create,
    Delete
}

function GetList(params= {}, expand = ''){
    return sendRequest('cash', 'GET', {filter: {...params}}, true)
}

function Create(data){
    return sendRequest('cash', 'POST', data, true)
}
function Delete(id){
    return sendRequest('cash/' + id, 'DELETE', {}, true)
}
function Update(id, data){
    if (!id || id === null || id === 'null') {
        return Promise.reject(new Error('Invalid operation ID: ' + id))
    }
    return sendRequest('cash/' + id, 'PUT', {...data}, true)
}

function GetCategories(){
    return sendRequest('cash/get-categories', 'GET', {}, true)
}

